import {releaseMode} from '../common/const';

import {fork} from 'redux-saga/effects';
import * as auth from './auth';
import * as menu from './menu';
import * as upload from './upload';
import * as mainList from './main-list';
import * as detailList from './detail-list';
import * as consigneeList from './consignee-list';
import * as consigneeListNew from './consignee-list-new';
import * as receiptList from './receipt-list';
import * as arrivalList from './arrival-list';
import * as deleteList from './delete-list';
import * as shipment from './shipment';
import * as shipmentDetail from './shipment-detail';
import * as entryList from './entry-list';
import * as entryDetail from './entry-detail';
import * as deliveryStatusList from './delivery-status-list';
import * as deliveryStatusDetail from "./delivery-status-detail";
import * as uploadReceipt from './upload-receipt';
import * as uploadReceiptNew from './upload-receipt-new';
import * as decodeProcessList from './decode-process-list';
import * as emptyPdf from './empty-pdf';
import * as masterCommon from './master/common';
import * as masterAddUser from './master/add-user';
import * as masterUsers from './master/users';
import * as masterNayose from './master/nayose';
import * as masterSecomSignature from './master/secom-signature';
import * as masterReceiptsReferences from './master/receipts-references';
import * as masterJigyousha from './master/jigyousha';
import * as masterKeiyakuKigyou from './master/keiyaku-kigyou';
import * as masterHasonhoukokuKbn from './master/hasonhoukoku-kbn';
import * as documents from './documents';
import * as information from './information';
import * as faq from './faq';
import * as statistics from './statistics';
import * as statisticsList from './statistics-list';
import * as mapping from './mapping';
import * as masterASNCorporateManagement from './master/asn-corporate-management'
import * as masterTrHenkan from './master/tr-henkan';
import * as masterAsnHenkan from './master/asncode-henkan';

export default function* rootSaga() {


	yield fork(menu.handleClickAgreeTerms);

	yield fork(auth.handleLogin);
	yield fork(auth.handleLogout);
	yield fork(auth.handleSendResetPassword);

	yield fork(upload.handleUploadData);
	yield fork(upload.handleDeleteUploadData);
	yield fork(upload.handleSaveUploadData);
	yield fork(upload.handleGetCsvTemplate);
	yield fork(upload.handleFetchCsvTemplateInfo);

	yield fork(mainList.handleFetchMainList);
	yield fork(mainList.handleFetchCsvDataFromMain);

	yield fork(detailList.handleFetchDetailList);
	yield fork(detailList.handleFetchCsvDataFromDetail);
	yield fork(detailList.handleGetPdf);
	yield fork(detailList.handleUpdatePrintFlag);

	yield fork(consigneeList.handleFetchConsigneeList);
	yield fork(consigneeList.handleUpdateConsigneeFlag);
	yield fork(consigneeList.handleUndoConsigneeFlag);
	yield fork(consigneeList.handleGetPdfConsignee);

	yield fork(consigneeListNew.handleFetchConsigneeListNew);
	yield fork(consigneeListNew.handleUpdateConsigneeFlagNew);
	yield fork(consigneeListNew.handleUndoConsigneeFlagNew);
	yield fork(consigneeListNew.handleGetPdfConsigneeNew);
	yield fork(consigneeListNew.handleFetchDecodeProcessManualCount);
	yield fork(consigneeListNew.handleGetPdfConsigneeMod);
	yield fork(consigneeListNew.handleFetchCsvDataFromConsigneeListNew);

	yield fork(receiptList.handleFetchReceiptList);
	yield fork(receiptList.handleGetPdfReceipt);
	yield fork(receiptList.handleGetPdfReceiptMod);
	yield fork(receiptList.handleUndoReceiptFlag);
	yield fork(receiptList.handleFetchCsvDataFromReceipt);
	yield fork(receiptList.handleGetPdfReceiptSecom);
	yield fork(receiptList.handleGetReceiptArrivalPdf);

	yield fork(arrivalList.handleFetchArrivalList);
	yield fork(arrivalList.handleUpdateArrivalFlag);
	yield fork(arrivalList.handleUndoArrivalFlag);
	yield fork(arrivalList.handleGetPdfArrival);
	yield fork(arrivalList.handleFetchCsvDataFromArrival);

	yield fork(deleteList.handleFetchDeleteList);
	yield fork(deleteList.handleUpdateDeleteFlag);

	yield fork(shipment.handleFetchShipmentData);
	yield fork(shipment.handleFetchShipmentRotationNO);
	yield fork(shipment.handleUpdateShipmentFlag);

	yield fork(shipmentDetail.handleFetchShipmentDetail);
	yield fork(shipmentDetail.handleGetPdfShipment);
	yield fork(shipmentDetail.handleSaveShipmentDetail);

	yield fork(entryList.handleFetchEntryList);
	yield fork(entryList.handleDeleteEntryList);

	yield fork(entryDetail.handleSaveEntry);
	yield fork(entryDetail.handleFetchEntryDetailData);

	yield fork(deliveryStatusList.handleFetchDeliveryStatusList);
	yield fork(deliveryStatusList.handleFetchCsvDataFromDeliveryStatus);

	yield fork(deliveryStatusDetail.handleFetchDeliveryStatusDetail);
	yield fork(deliveryStatusDetail.handleFetchCsvDataFromDeliveryStatusDetail);
	yield fork(deliveryStatusDetail.handleGetPdfDeliveryStatusDetail);
	yield fork(deliveryStatusDetail.handleGetPdfDeliveryStatusMod);
	yield fork(deliveryStatusDetail.handleGetPdfDeliveryStatusSecom);

	yield fork(uploadReceipt.handleUploadDecodeTarget);
	yield fork(uploadReceipt.handleUploadManualDecodes);

	yield fork(uploadReceiptNew.handleUploadDecodeTargetNew);

	yield fork(decodeProcessList.handleFetchDecodeProcessList);
	yield fork(decodeProcessList.handleUploadManualDecodeNew);
	yield fork(decodeProcessList.handleCancelManualDecode);

	yield fork(emptyPdf.handleGetEmptyPdf);
	yield fork(emptyPdf.handleFetchEmptyPdfList);

	yield fork(masterCommon.handleGetUserList);
	yield fork(masterCommon.handleGetJigyoshaList);
	yield fork(masterCommon.handleGetKeiyakuKigyouList);
	yield fork(masterCommon.handleGetASNRenkeiList);
	yield fork(masterCommon.handleGetDenpyoYoshikiList);
	yield fork(masterCommon.handleGetHasonhoukokuKbnList);
	yield fork(masterCommon.handleGetAsnCorporateList);
	yield fork(masterCommon.handleGetTrHenkanList);
	yield fork(masterCommon.handleGetAsnHenkanList);
	yield fork(masterCommon.handleGetAsnList);

	yield fork(masterJigyousha.handleGetJigyosha);
	yield fork(masterJigyousha.handleGetJigyoshaListWD);
	yield fork(masterJigyousha.handleSetJigyosha);
	yield fork(masterJigyousha.handleDelJigyosha);
	yield fork(masterJigyousha.handleRestoreJigyosha);
	yield fork(masterJigyousha.handleGetButsuryuBoten);
	yield fork(masterJigyousha.handleGetMaker);

	yield fork(masterKeiyakuKigyou.handleGetKeiyakuKigyouListWD);
	yield fork(masterKeiyakuKigyou.handleGetKeiyakuKigyou);
	yield fork(masterKeiyakuKigyou.handleSetKeiyakuKigyou);
	yield fork(masterKeiyakuKigyou.handleDelKeiyakuKigyou);
	yield fork(masterKeiyakuKigyou.handleRestoreKeiyakuKigyou);


	yield fork(masterAddUser.handleGetUserData);
	yield fork(masterAddUser.handleSetUserData);

	yield fork(masterUsers.handleSetUserList);
	yield fork(masterUsers.handleGetUserListCsv);
	yield fork(masterUsers.handleGetUserQrPdf);

	yield fork(masterNayose.handleGetNayoseList);
	yield fork(masterNayose.handleSetNayoseList);
	yield fork(masterNayose.handleGetNayoseListCsv);

	yield fork(masterSecomSignature.handleGetSecomSignatureList);
	yield fork(masterSecomSignature.handleSetSecomSignatureList);
	yield fork(masterSecomSignature.handleGetSecomSignatureListCsv);
	yield fork(masterHasonhoukokuKbn.handleSetHasonhoukokuKbnList);
	yield fork(masterHasonhoukokuKbn.handleGetHasonhoukokuKbnListCsv);
	yield fork(masterReceiptsReferences.handleGetReceiptsReferencesList);
	yield fork(masterReceiptsReferences.handleSetReceiptsReferencesList);
	yield fork(masterReceiptsReferences.handleGetReceiptsReferencesListCsv);

	yield fork(documents.handleShowManuals);
	yield fork(documents.handleShowPolicy);
	yield fork(documents.handleShowTerms);

	yield fork(information.handleFetchInformationList);

	yield fork(faq.handleFetchFaqList);

	yield fork(statistics.handleFetchStatisticsInfo);
	yield fork(statistics.handleAddStatisticsInfo);
	yield fork(statistics.handleUpdStatisticsInfo);
	yield fork(statistics.handleDelStatisticsInfo);

	yield fork(statisticsList.handleFetchStatisticsList);
	yield fork(statisticsList.handleGetStatisticsExcel);


	yield fork(mapping.handleFetchMappingInfo);
	yield fork(mapping.handleSetMappingInfo);
	yield fork(mapping.handleDelMappingInfo);

	yield fork(masterASNCorporateManagement.handleSetAsnCorporateList);
	yield fork(masterASNCorporateManagement.handleGetAsnCorporateListCsv);

	yield fork(masterAsnHenkan.handleGetAsnHenkanListCsv);
	yield fork(masterAsnHenkan.handleSetAsnHenkanList);


	yield fork(masterTrHenkan.handleSetTrHenkanList);
	yield fork(masterTrHenkan.handleGetTrHenkanListCsv);
}

export function getApiUrl() {
	if (releaseMode() === 0) {
		//DEV
		return 'http://telesa-delivery-api/';
	} else {
		//RELEASE
		return '/api/';
	}
}

export function getWpApiUrl() {
	switch (releaseMode()) {
		case 2: //STG
			return 'https://telesa-delivery-tdkjbn-stg.tsunagute.co.jp/telesa-delivery/wp-json/custom/';
		case 3: //PROD
		case 4: //BCP
			return 'https://telesa-delivery-tdkjbn.tsunagute.co.jp/telesa-delivery/wp-json/custom/';
		default: //DEVELOPMENT & DEV SERVER
			return 'https://telesa-delivery-tdkjbn.tsunagute.co.jp/telesa-delivery/wp-json/custom/';
	}
}



// WEBPACK FOOTER //
// ./src/sagas/index.js